import * as React from 'react';
import * as UsersRepository from '../../../Repository/UserRepository';
import CRUDModal from "../../../Component/Modal/CRUDModal";
import { TeamOutlined } from "@ant-design/icons";
import { Col, Row, Select, Spin } from 'antd';
import { useState } from 'react';
import { impersonate } from "./AdminUsersPage";

const { Option } = Select;

export default function ModalImpersonation() {
  const [value, setValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  let abortController: AbortController|undefined;

  const onSearch = async (search: string) => {
    if (abortController) {
      abortController.abort();
    }

    abortController = new AbortController();
    await setLoading(true);
    await UsersRepository.getAdminUsersList({
      controller: abortController,
      params: {
        filters: JSON.stringify([
          { field: "search", value: search }
        ])
      },
      successCallback: (response: any) => {
        setOptions(response);
        abortController = undefined;
      },
      errorCallback: (err: any) => {
        console.error(err);
        abortController = undefined;
      },
    });
    await setLoading(false);
  };

  return (
    <CRUDModal
      openButton={<>Impersonate user <TeamOutlined /></>}
      modalTitle={'Select user to impersonate'}
      closeAfterSave={true}
      onSave={async () => {
        await setLoading(false);
        impersonate(value);
      }}
    >
      <Row>
        <Col span={24}>
          <Select
            style={{ width: '100%' }}
            showSearch
            value={value}
            placeholder={'Search'}
            defaultActiveFirstOption={false}
            showArrow={false}
            filterOption={false}
            onSearch={onSearch}
            onChange={setValue}
            notFoundContent={loading ? <>Loading... <Spin size="small" /></> : null}
            loading={true}
          >
            {options.map((record: any) => {
              return <Option key={record.email} value={record.email}>{record.email}</Option>
            })}
          </Select>
        </Col>
      </Row>
    </CRUDModal>
  );
}